import {combineReducers} from 'redux'

import {reducer as userReducer} from "./reducers/user/reducer";
import {reducer as workerReducer} from "./reducers/worker/reducer";
import {reducer as vatsReducer} from "./reducers/vats/reducer";
import {reducer as workplacesReducer} from "./reducers/workplaces/reducer";
import {reducer as workersReducer} from "./reducers/workers/reducer";
import {reducer as workshopReducer} from "./reducers/workshop/reducer";
import {reducer as repairOrderStatusesReducer} from "./reducers/repairOrderStatuses/reducer";
import {reducer as suppliersReducer} from "./reducers/suppliers/reducer";
import {reducer as jobCategoriesReducer} from "./reducers/jobCategories/reducer";
import {reducer as bsxPrinterAuthsReducer} from "./reducers/bsxPrinterAuths/reducer";
import {reducer as screenBackgroundReducer} from "./reducers/screenBackground/reducer";
import smsModalContainerReducer from "./components/SmsModalContainer/reducer/ModalReducer";
import emailModalContainerReducer from "./components/EmailModalContainer/reducer/ModalReducer";
import suppliersContainerReducer from "./components/Supplier/SuppliersModal/reducer/ModalReducer";
import vehicleByRegNumberModalReducer
  from "./components/VehicleByRegNumber/VehicleByRegNumberModal/reducer/ModalReducer";

export default combineReducers({
  user: userReducer,
  worker: workerReducer,
  vats: vatsReducer,
  workplaces: workplacesReducer,
  workers: workersReducer,
  workshop: workshopReducer,
  repairOrderStatuses: repairOrderStatusesReducer,
  suppliers: suppliersReducer,
  jobCategories: jobCategoriesReducer,
  bsxPrinterAuths: bsxPrinterAuthsReducer,
  screenBackground: screenBackgroundReducer,

  smsModalContainer: smsModalContainerReducer,
  emailModalContainer: emailModalContainerReducer,
  suppliersContainer: suppliersContainerReducer,
  vehicleByRegNumberModal: vehicleByRegNumberModalReducer,
})
